import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogOut, User } from "lucide-react";

const LOGO_URL = "https://customer-assets-wrfwihn1.emergentagent.net/job_nebula-lands/artifacts/xh1qfl77_grok_1784389902421.jpg-removebg-preview.png";

export default function Navbar() {
  const { user, login, logout } = useAuth();
  const loc = useLocation();
  const on = (p) => loc.pathname === p;

  return (
    <header className="fixed top-0 inset-x-0 z-40 glass-dark border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
          <img
            src={LOGO_URL}
            alt="Teuralink"
            className="w-11 h-11 object-contain drop-shadow-[0_0_10px_rgba(212,175,55,0.35)] transition-transform group-hover:scale-105"
          />
          <span className="font-display text-xl font-bold tracking-tight">Teuralink</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-white/70">
          <Link to="/explore/moon" className={`hover:text-white transition ${on("/explore/moon") ? "text-white" : ""}`} data-testid="nav-moon">Moon</Link>
          <Link to="/explore/mars" className={`hover:text-white transition ${on("/explore/mars") ? "text-white" : ""}`} data-testid="nav-mars">Mars</Link>
          <Link to="/frames" className={`hover:text-white transition ${on("/frames") ? "text-white" : ""}`} data-testid="nav-frames">Frames</Link>
          <Link to="/track" className={`hover:text-white transition ${on("/track") ? "text-white" : ""}`} data-testid="nav-track">Track</Link>
          <Link to="/verify" className={`hover:text-white transition ${on("/verify") ? "text-white" : ""}`} data-testid="nav-verify">Verify</Link>
          <Link to="/legal" className={`hover:text-white transition ${on("/legal") ? "text-white" : ""}`} data-testid="nav-legal">Legal</Link>
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Link to={user.role === "admin" ? "/admin" : "/dashboard"} className="btn-ghost !py-2 !px-4 text-sm" data-testid="nav-dashboard">
                <User className="w-4 h-4" />
                <span className="hidden sm:inline">{user.name?.split(" ")[0] || "Account"}</span>
              </Link>
              <button onClick={logout} className="text-white/60 hover:text-white p-2" data-testid="nav-logout" title="Log out">
                <LogOut className="w-4 h-4" />
              </button>
            </>
          ) : (
            <button onClick={login} className="btn-primary !py-2 !px-4 text-sm" data-testid="nav-login">Sign in</button>
          )}
        </div>
      </div>
    </header>
  );
}
